import React, { useState, useRef } from "react";

const DIRTY_API =
  "https://46gzkdp5vf.execute-api.us-west-1.amazonaws.com/default/shopify-dirty-orders";

const META_API =
  "https://46gzkdp5vf.execute-api.us-west-1.amazonaws.com/default/cin7-order-meta";

export default function DirtyOrders() {
  const [data, setData] = useState([]);
  const [start, setStart] = useState("");
  const [loading, setLoading] = useState(false);
  const [showGif, setShowGif] = useState(false);

  const [notes, setNotes] = useState({});
  const [resolved, setResolved] = useState({});
  const [saving, setSaving] = useState({});
  const [typing, setTyping] = useState({});

  // 🔥 IMPORTANT: persist timers across renders
  const noteTimers = useRef({});

  const cleanOrderId = (name) => String(name || "").replace("#", "");

  const loadMeta = async (orders) => {
    const ids = orders.map((o) => cleanOrderId(o.name)).join(",");
    if (!ids) return;

    const res = await fetch(`${META_API}?ids=${encodeURIComponent(ids)}`);
    const json = await res.json();

    setNotes(json.notes || {});
    setResolved(json.resolved || {});
  };

  const run = async () => {
    if (!start) return alert("Please select a start date");

    setLoading(true);

    const res = await fetch(`${DIRTY_API}?start=${start}`);
    const json = await res.json();

    const orders = json.orders || [];
    setData(orders);

    await loadMeta(orders);

    setLoading(false);
  };

  const copyOrderId = (name) => {
    navigator.clipboard.writeText(cleanOrderId(name));
  };

  const saveMeta = async (orderId, payload) => {
    setSaving((prev) => ({ ...prev, [orderId]: true }));

    try {
      await fetch(META_API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          orderId,
          ...payload
        })
      });
    } catch (err) {
      console.error(err);
      alert(`Failed to save order #${orderId}`);
    } finally {
      setSaving((prev) => ({ ...prev, [orderId]: false }));
    }
  };

  const toggleResolved = async (name) => {
    const id = cleanOrderId(name);
    const newValue = !resolved[id];

    setResolved((prev) => ({
      ...prev,
      [id]: newValue
    }));

    await saveMeta(id, { resolved: newValue });
  };

  // 🔥 FIXED debounce (this is the key change)
  const updateNote = (name, value) => {
    const id = cleanOrderId(name);

    setNotes((prev) => ({
      ...prev,
      [id]: value
    }));

    // show typing
    setTyping((prev) => ({
      ...prev,
      [id]: true
    }));

    // clear existing timer
    if (noteTimers.current[id]) {
      clearTimeout(noteTimers.current[id]);
    }

    // set new timer
    noteTimers.current[id] = setTimeout(async () => {
      setTyping((prev) => ({
        ...prev,
        [id]: false
      }));

      await saveMeta(id, { note: value });
    }, 500);
  };

  const resolvedCount = Object.values(resolved).filter(Boolean).length;

  return (
    <div
      style={{
        maxWidth: 1000,
        margin: "40px 0",
        padding: 20,
        background: "#fff",
        borderRadius: 8,
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
      }}
    >
      <h2 style={{ marginBottom: 15 }}>
        <span
          onClick={() => setShowGif(true)}
          style={{ cursor: "pointer", marginRight: 6 }}
        >
          ⚠️
        </span>
        Exchange Orders For Reimport to Cin7
      </h2>

      <div style={{ display: "flex", gap: 10, marginBottom: 15 }}>
        <input
          type="date"
          value={start}
          onChange={(e) => setStart(e.target.value)}
        />

        <button onClick={run}>
          {loading ? "Loading..." : "Load Orders"}
        </button>
      </div>

      <div style={{ marginBottom: 10 }}>
        <strong>Total:</strong> {data.length} (Resolved: {resolvedCount})
      </div>

      <div style={{ maxHeight: 400, overflowY: "auto" }}>
        {data.map((order) => {
          const id = cleanOrderId(order.name);
          const isDone = resolved[id];

          return (
            <div
              key={order.name}
              style={{
                padding: 12,
                borderBottom: "1px solid #eee",
                opacity: isDone ? 0.5 : 1
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <strong>{order.name}</strong>

               <button
  onClick={() => copyOrderId(order.name)}
  style={{
    padding: "2px 6px",
    fontSize: 11,
    cursor: "pointer"
  }}
>
  Copy ID
</button>

               <button
  onClick={() => toggleResolved(order.name)}
  style={{
    padding: "2px 6px",
    fontSize: 11,
    cursor: "pointer",
    background: isDone ? "#dc2626" : "#16a34a",
    color: "#fff",
    border: "none",
    borderRadius: 3
  }}
>
  {isDone ? "Undo" : "Done"}
</button>

                {/* 🔥 Status indicators */}
                {typing[id] && <span>Typing...</span>}
                {!typing[id] && saving[id] && <span>Saving...</span>}
              </div>

           <div style={{ fontSize: 12, color: "#666" }}>
                {new Date(order.created_at).toLocaleString()}
              </div>

              <div>
                <span style={{ color: "#b91c1c", fontWeight: 600 }}>
  Removed:
</span> {order.removed.join(", ")}
              </div>

              <div>
                <span style={{ color: "#065f46", fontWeight: 600 }}>
  Added:
</span> {order.added.join(", ")}
              </div>

     <textarea
  value={notes[id] || ""}
  onChange={(e) => updateNote(order.name, e.target.value)}
  placeholder="Add note..."
  style={{
    marginTop: 8,
    width: "100%",
    minHeight: 52,
    fontSize: 12,
    padding: 6,
    borderRadius: 4,
    border: "1px solid #ddd",
    boxSizing: "border-box",
    resize: "vertical"
  }}
/>
            </div>
          );
        })}
      </div>

    {showGif && (
  <div
    onClick={() => setShowGif(false)}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.7)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      cursor: "pointer"
    }}
  >
    <div style={{ textAlign: "center" }}>
      <img
        src="https://media1.tenor.com/m/gkPjiDshvj0AAAAC/click.gif"
        alt="Click guide"
        style={{
          maxWidth: "80vw",
          maxHeight: "80vh",
          borderRadius: 8,
          boxShadow: "0 10px 30px rgba(0,0,0,0.5)"
        }}
      />

      <div style={{ color: "#fff", marginTop: 10, fontSize: 14 }}>
        Click anywhere to close
      </div>
    </div>
  </div>
)}

</div>
);
}
